/// <reference path="ProductCategoryViewController.ts" />

type ProductCategorySelectionCallback = (selectedCategory: ProductCategory) => void;



class ProductCategorySelectionViewController extends ProductCategoryViewController
{
    selectionBlock: ProductCategorySelectionCallback | null = null;

    viewDidLoad(){
        super.viewDidLoad();
        
        this.sectionsButton.hidden = true;
        this.addButton.hidden = true;
        this.clearButton.hidden = false;
    }

    get preferredContentSize(){
        return new MIOSize(320, 500);
    }

    didSelectedCategory(category:ProductCategory){
        super.didSelectedCategory(category);
        if (this.selectionBlock != null) {
            this.selectionBlock(this.selectedItem);
        }
        this.dismissViewController(true);
    }

}

